var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEstrellavacia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 128,
    zoomAndPan: "magnify",
    viewBox: "0 0 96 95.999999",
    height: 128,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "7bf8d4abf2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 2.25 L 96 2.25 L 96 93.75 L 0 93.75 Z M 0 2.25 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0c44d421df"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 48 2.25 L 59.332031 37.199219 L 96 37.199219 L 66.335938 58.800781 L 77.664062 93.75 L 48 72.148438 L 18.335938 93.75 L 29.664062 58.800781 L 0 37.199219 L 36.667969 37.199219 L 48 2.25 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7bf8d4abf2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0c44d421df)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.75, 0, 0, 0.75, 0.0000005, 2.250009)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 64.000003 -0.0000122704 L 79.109378 46.598948 L 128.000006 46.598948 L 88.447921 75.401033 L 103.552088 121.999994 L 64.000003 93.197909 L 24.447917 121.999994 L 39.552085 75.401033 L -0.000000666667 46.598948 L 48.890627 46.598948 L 64.000003 -0.0000122704 ",
    stroke: "#579872",
    strokeWidth: 2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstrellavacia);
export default __webpack_public_path__ + "static/media/estrella.vacia.2d0f87b99b1888d7ce71f7aeb09dde95.svg";
export { ForwardRef as ReactComponent };